import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';
import { ACMEResponse, ContentHeaderProps, TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';
import { MembershipOfferingsControllerModule } from '../../../offerings/controllers/MembershipOfferingsController';

MembershipLevelsCreateController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  '$filter',
  '$timeout',
  'ApiService',
  'HelpersService',
  'CalendarService',
  'UserPreferencesService',
  'NoticeFactory',
  'SalesChannelsFactory',
  'PermissionsService',
  'ViewStateService',
  'MembershipLevelCollections',
  'ThemesHelperService',
];

function MembershipLevelsCreateController(
  $scope: IScope & { membershipLevelsCreate: TODO },
  $state: StateService,
  $uibModal: UIBModalService,
  $filter: IFilterService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  HelpersService: TODO,
  CalendarService: CalendarService,
  UserPreferencesService: UserPreferencesService,
  NoticeFactory: NoticeFactory,
  SalesChannelsFactory: TODO,
  PermissionsService: PermissionsService,
  ViewStateService: TODO,
  MembershipLevelCollections: { data: ACMEResponse<TODO> },
  ThemesHelperService: ThemesHelperService
) {
  const ctrl = {
    model: {
      name: '',
      membershipLevelGroup: 'organization',
      rules: {
        canGift: true,
        startBeginningOfMonth: false,
        expireEndOfMonth: false,
        numberOfCardHolders: 0,
      },
      auxiliary: false,
      membershipLevelCollection: [],
    } as TODO,
    mode: 'create',
    levelId: '',
    tab: 'description',
    notice: new NoticeFactory(),
    company: ThemesHelperService.getCompany(),
    profileImageUploadStatus: 'Change',
    lastUpdated: '',
    lastPublished: '',
    addOrgCardholder: false,
    numberOfCardHolders: 0,
    descriptionRemaining: 300,
    descriptionMax: 300,

    isSubmitted: false,
    isLoadingImage: false,
    categoryId: '',
    isGroupIndividualFamily: false,
    isRegular: true,
    isAuxiliaryMembershipEnabled: false,

    summernoteConfig: {
      height: 300,
      focus: false,
      shortcuts: false,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
      ],
    },
    membershipLevelCollection: [] as TODO[],
    selectedMembershipLevelCollection: {} as TODO,

    dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),
    hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

    init: function () {
      if (MembershipLevelCollections.data && MembershipLevelCollections.data.success) {
        ctrl.success.getMembershipLevelCollections(MembershipLevelCollections);
      }

      if ($state.params) {
        ctrl.handleEditViewMode();
        ctrl.handleAuxilaryOptions();
        ctrl.handleGroupTypeToggle();
      }

      $scope.$emit('Application::contentTitleChange', {
        title: HelpersService.cap(ctrl.mode) + ' Membership Level',
        buttonRight: {
          permissions: ['MEMBERSHIP_CATEGORY_CREATE'],
          label: ctrl.isMode('edit') ? 'Save' : 'Create & Continue',
          action: () => {
            ctrl.complete();
          },
        },
        buttonLeft: {
          label: 'Close',
          action: () => {
            ctrl.close();
          },
        },
      } as ContentHeaderProps);

      $scope.$on('$destroy', $scope.$watch('membershipLevelsCreate.addOrgCardholder', ctrl.onAddOrgCardholderUpdate));

      $scope.$on('upload::error', ctrl.onUploadError);
      $scope.$on('upload::done', ctrl.onUploadDone);
      $scope.$on('upload::add', ctrl.onUploadAdd);

      $scope.$on('MembershipOfferings::Remove', ctrl.onMembershipOfferingRemoved);
      $scope.$on('MembershipOfferings::Error', ctrl.onMembershipOfferingError);
    },

    handleEditViewMode: function () {
      if ($state.params.categoryId) {
        ctrl.mode = 'edit';
        ctrl.getLevel($state.params.categoryId);
        ctrl.categoryId = $state.params.categoryId;
      }
    },

    handleAuxilaryOptions: function () {
      if (ctrl.company && ctrl.company.auxiliaryMembership) {
        ctrl.isAuxiliaryMembershipEnabled = ctrl.company.auxiliaryMembership;
        if ($state.params.auxiliary) {
          ctrl.isRegular = false;
        }
        if ($state.params.groupId && !ctrl.isMode('edit')) {
          ctrl.setMembershipLevelCollection($state.params.groupId);
        }
      }
    },

    handleGroupTypeToggle: function () {
      switch ($state.params.group) {
        case 'organization':
          ctrl.model.membershipLevelGroup = 'organization';
          break;
        case 'individualAndFamily':
        /* falls through */
        default:
          ctrl.model.membershipLevelGroup = 'individualAndFamily';
          ctrl.isGroupIndividualFamily = true;
      }
    },

    hasOfferings: function () {
      return ctrl.model.offerings instanceof Array && ctrl.model.offerings.length;
    },

    isValidName: function () {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ctrl.model.name && ctrl.model.name.replace(/\s/g, '').length > 0;
      }

      return r;
    },

    validate: function (publish = false) {
      let r;

      ctrl.isSubmitted = true;
      ctrl.notice.hideErrorMessages();
      ctrl.notice.hideSuccessMessages();

      if (publish) {
        r = ctrl.isValidName() && ctrl.hasOfferings();

        if (!ctrl.hasOfferings()) {
          ctrl.notice.showErrorMessages([{ message: 'Add offerings to publish membership level' }]);
        }
      } else {
        r = ctrl.isValidName();
      }

      return r;
    },

    prepare: function () {
      const numberOfCardHolders = parseInt(ctrl.numberOfCardHolders as TODO, 10);

      if (ctrl.isGroupIndividualFamily === false) {
        ctrl.model.membershipLevelGroup = 'organization';
        ctrl.isRegular = true;
        if (ctrl.addOrgCardholder) {
          ctrl.model.rules.numberOfCardHolders = 1;
        } else {
          ctrl.model.rules.numberOfCardHolders = numberOfCardHolders > 0 ? numberOfCardHolders + 1 : 0;
        }
      } else if (ctrl.isGroupIndividualFamily === true) {
        ctrl.model.membershipLevelGroup = 'individualAndFamily';
        ctrl.model.rules.numberOfCardHolders = numberOfCardHolders + 1;
      }
      if (!ctrl.isRegular && ctrl.selectedMembershipLevelCollection && ctrl.selectedMembershipLevelCollection.id) {
        ctrl.model.membershipLevelCollection = [ctrl.selectedMembershipLevelCollection];
      } else {
        ctrl.model.membershipLevelCollection = null;
      }
      ctrl.model.auxiliary = !ctrl.isRegular;
    },

    create: function () {
      if (ctrl.validate()) {
        ctrl.model.state = 'draft';
        ctrl.model.salesChannels = new SalesChannelsFactory().init();

        ctrl.prepare();

        ApiService.membership.categories
          .create(ctrl.model)
          .then((response) => ctrl.success.create(response))
          .catch((response) => ctrl.error.create(response));
      }
    },

    update: function () {
      if (ctrl.validate()) {
        if (!ctrl.model.state) {
          ctrl.model.state = 'draft';
        }

        ctrl.prepare();

        ApiService.membership.categories
          .update(ctrl.model)
          .then((response) => ctrl.success.update(response))
          .catch((response) => ctrl.error.update(response));
      }
    },

    publish: function () {
      if (ctrl.validate(true)) {
        if (!ctrl.model.state) {
          ctrl.model.state = 'draft';
        }

        ctrl.prepare();

        ApiService.membership.categories
          .publish(ctrl.model)
          .then((response) => ctrl.success.publish(response))
          .catch((response) => ctrl.error.publish(response));
      }
    },

    isState: function (state) {
      return ctrl.model.state === state;
    },

    close: function () {
      const data: TODO = {};

      if (!ctrl.isRegular) {
        data.auxiliary = '1';
      }

      if (!ctrl.isGroupIndividualFamily) {
        data.group = 'organization';
      }

      if (ctrl.selectedMembershipLevelCollection && ctrl.selectedMembershipLevelCollection.id) {
        data.groupId = ctrl.selectedMembershipLevelCollection.id;
      }

      ViewStateService.setState('membership.levels', data);
      $state.go('application.membership.levels');
    },

    complete: function () {
      ctrl.notice.hideErrorMessages();
      ctrl.notice.hideSuccessMessages();

      if (ctrl.isMode('edit')) {
        ctrl.update();
      } else {
        ctrl.create();
      }
    },

    save: function (publish) {
      if (ctrl.isMode('edit')) {
        if (publish) {
          ctrl.publish();
        } else {
          ctrl.update();
        }
      } else {
        ctrl.create();
      }
    },

    saveContinue: function () {
      ctrl.create();
    },

    remove: function () {
      $uibModal
        .open<TODO>({
          templateUrl: 'views/application/views/membership/levels/create/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'MembershipLevelsCreateModalsRemoveController',
          resolve: {
            currentLevel: () => ctrl.model,
          },
        })
        .result.then(() => {
          ApiService.membership.categories
            .remove({ id: ctrl.model.id })
            .then((response) => ctrl.success.remove(response))
            .catch((response) => ctrl.error.remove(response));
        })
        .catch(() => {
          // noop
        });
    },

    isMode: function (mode) {
      return ctrl.mode === mode;
    },

    isTab: function (tab) {
      return ctrl.tab === tab;
    },

    getLevel: function (id) {
      ApiService.membership.categories
        .detail(id)
        .then((response) => ctrl.success.getLevel(response))
        .catch((response) => ctrl.error.getLevel(response));
    },

    getTab: function (tab) {
      ctrl.tab = tab;
    },

    checkShortDescription: function () {
      if (ctrl.model.shortDescription) {
        ctrl.model.shortDescription = ctrl.model.shortDescription.replace(/[\s\n]+/g, ' ');
        const len = HelpersService.getTextLength(ctrl.model.shortDescription);

        if (len > ctrl.descriptionMax) {
          ctrl.model.shortDescription = ctrl.model.shortDescription.substr(0, ctrl.descriptionMax);
        }
      } else {
        ctrl.model.shortDescription = '';
      }

      ctrl.descriptionRemaining = ctrl.descriptionMax - HelpersService.getTextLength(ctrl.model.shortDescription);
    },

    showBenefits: function () {
      $uibModal
        .open<TODO>({
          templateUrl: 'views/application/views/membership/benefits/modals/add/add.tpl.html',
          size: 'md',
          controller: 'MembershipBenefitsModalsAddController',
          resolve: {
            editable: () => true,
            currentBenefits: () => ctrl.model.benefits,
          },
        })
        .result.then((benefits) => {
          ctrl.model.benefits = benefits;
        })
        .catch(() => {
          // noop
        });
    },

    findMembershipLevelCollection: function (id: TODO) {
      let r: TODO | false = false;

      for (let i = 0, ii = ctrl.membershipLevelCollection.length; i < ii; i++) {
        if (ctrl.membershipLevelCollection[i].id === id) {
          r = {
            membershipLevelCollectionItem: ctrl.membershipLevelCollection[i],
            index: i,
          };
          break;
        }
      }

      return r;
    },

    setMembershipLevelCollection: function (id) {
      const found = ctrl.findMembershipLevelCollection(id);

      if (found) {
        ctrl.selectedMembershipLevelCollection = found.membershipLevelCollectionItem;
      }
    },

    process: function (level) {
      if (level.rules.numberOfCardHolders > 0) {
        if (level.rules.numberOfCardHolders === 1 && level.membershipLevelGroup === 'organization') {
          ctrl.addOrgCardholder = true;
        } else {
          ctrl.numberOfCardHolders = parseInt(level.rules.numberOfCardHolders, 10) - 1;
        }
      } else {
        ctrl.numberOfCardHolders = 0;
      }

      if (level.lastPublishedAt) {
        ctrl.lastPublished =
          $filter('date')(CalendarService.parseDate(level.lastPublishedAt), ctrl.dateFormat) +
          ' at ' +
          $filter('date')(CalendarService.parseDate(level.lastPublishedAt), ctrl.hourFormat);
      }

      if (level.lastUpdatedAt) {
        ctrl.lastUpdated =
          $filter('date')(CalendarService.parseDate(level.lastUpdatedAt), ctrl.dateFormat) +
          ' at ' +
          $filter('date')(CalendarService.parseDate(level.lastUpdatedAt), ctrl.hourFormat);
      }

      ctrl.isRegular = !level.auxiliary;
      ctrl.isGroupIndividualFamily = level.membershipLevelGroup === 'individualAndFamily';

      if (level.membershipLevelCollection instanceof Array && level.membershipLevelCollection.length) {
        ctrl.selectedMembershipLevelCollection = level.membershipLevelCollection[0];
      } else if ($state.params.groupId) {
        ctrl.setMembershipLevelCollection($state.params.groupId);
      }

      return level;
    },

    removePhoto: function () {
      ctrl.model.images = [];
    },

    success: {
      init: function (response) {},

      create: function (response) {
        ctrl.isSubmitted = false;
        $state.go('application.membership.levels.edit', { categoryId: response.data.payload.id });
      },

      update: function (response) {
        ctrl.model = ctrl.process(response.data.payload);
        ctrl.isSubmitted = false;
        ctrl.notice.showSuccessMessages([{ message: 'Successfully updated.' }], { duration: 3000 });
      },

      publish: function (response) {
        ctrl.model = ctrl.process(response.data.payload);
        ctrl.isSubmitted = false;

        ctrl.notice.showSuccessMessages([{ message: 'Successfully published.' }], { duration: 3000 });
      },

      remove: function (response) {
        ctrl.isSubmitted = false;
        ctrl.close();
      },

      getLevel: function (response) {
        ctrl.model = ctrl.process(response.data.payload);

        $scope.$broadcast('MembershipOfferings::Update', { offerings: ctrl.model.offerings });
      },

      getMembershipLevelCollections: function (response) {
        ctrl.membershipLevelCollection = response.data.payload.list;
      },
    },

    error: {
      init: function (response) {},
      generic: function (response) {
        ctrl.isSubmitted = false;
        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },
      create: function (response) {
        ctrl.error.generic(response);
      },
      update: function (response) {
        ctrl.error.generic(response);
      },
      publish: function (response) {
        ctrl.error.generic(response);
      },
      remove: function (response) {
        ctrl.error.generic(response);
      },
      getLevel: function (response) {
        ctrl.error.generic(response);
      },
      getMembershipLevelCollections: function (response) {
        ctrl.error.generic(response);
      },
    },

    onUploadDone: function (e, data) {
      ctrl.notice.hideErrorMessages();
      ctrl.profileImageUploadStatus = 'Change';
      ctrl.isLoadingImage = false;

      if (!(ctrl.model.images instanceof Array)) {
        ctrl.model.images = [];
      }

      ctrl.model.images = [
        {
          id: data.file.uuid,
          extension: data.file.extension,
          highRes: data.file.highResPath,
          original: data.file.originalPath,
          preview: data.file.previewPath,
          screen: data.file.screenPath,
          thumbnail: data.file.thumbnailPath,
          uuid: data.file.uuid,
        },
      ];

      $scope.$apply();
    },

    onUploadError: function (e, data) {
      ctrl.notice.showErrorMessages([{ message: data.result.error || 'There was a problem uploading that file.' }]);
    },

    onUploadAdd: function (e, data) {
      ctrl.notice.hideErrorMessages();

      ctrl.isLoadingImage = true;
      ctrl.profileImageUploadStatus = 'Uploading...';
      ctrl.model.images = [];
    },

    onAddOrgCardholderUpdate: function (n, o) {
      if (n) {
        ctrl.numberOfCardHolders = 0;
      }
    },

    onMembershipOfferingRemoved: function (e, data) {
      if (ctrl.isMode('edit') && $state.params.categoryId) {
        ctrl.getLevel($state.params.categoryId);
      }
    },

    onMembershipOfferingError: function (e, data) {
      if (data) {
        ctrl.error.generic(data);
      }
    },
  };

  $scope.membershipLevelsCreate = ctrl;
  ctrl.init();
}

export const MembershipLevelsCreateControllerModule = angular
  .module('acme.view.application.membership.levels.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.userPreferences',
    'acme.common.service.permissions',
    'acme.common.service.viewState',
    'acme.common.service.themesHelper',
    'acme.common.factory.notice',
    'acme.common.factory.salesChannels',
    'acme.common.directive.fieldFocus',
    MembershipOfferingsControllerModule,
    'acme.view.application.membership.benefits.modals.add.controllers',
    'acme.view.application.membership.levels.create.modals.remove.controllers',
  ])
  .controller('MembershipLevelsCreateController', MembershipLevelsCreateController).name;
